import { render } from "./SlideShow.vue?vue&type=template&id=18d3ca68"
import script from "./SlideShow.vue?vue&type=script&lang=js"
export * from "./SlideShow.vue?vue&type=script&lang=js"

import "./SlideShow.vue?vue&type=style&index=0&id=18d3ca68&lang=scss"

import exportComponent from "/codebuild/output/src1814515978/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__